<template>
  <Primitive
    :as="as"
    :class="
      cn(
        'flex flex-col md:flex-row-reverse md:items-center md:justify-center gap-2',
        props.class
      )
    "
  >
    <Button
      v-for="priority in priorities"
      :key="priority.id"
      :label="$t(`components.priority.${priority.id}`)"
      variant="secondary"
      type="gray"
      :active="selectedPriority === priority.id"
      :class="
        cn(
          'w-full md:w-40 md:h-24 py-2',
          getColor(selectedPriority === priority.id, priority.id)
        )
      "
      @click="selectedPriority = priority.id"
    />
  </Primitive>
</template>

<script setup>
import { computed, ref } from "vue";
import { Primitive } from "radix-vue";
import { usePage } from "@inertiajs/vue3";
import { Button } from "@/SharedComponents/Buttons";
import { cn } from "@/Utils/cn";

const emit = defineEmits(["submit"]);

const props = defineProps({
  initialState: { type: String, required: true },
  as: { type: null, default: "div" },
  class: { type: null, required: false },
});

const selectedPriority = ref(props.initialState);

const priorities = usePage().props.priorities;

function getColor(isActive, priority) {
  if (isActive) {
    switch (priority) {
      case "low":
        return "!text-utility-gray-400 !border-utility-gray-400 !bg-utility-gray-50";
      case "normal":
        return "!text-utility-warning-400 !border-utility-warning-400 !bg-utility-warning-50";
      case "high":
        return "!text-utility-error-500 !border-utility-error-500 !bg-utility-error-50";
    }
  }
  return {};
}

const isDirty = computed(() => {
  return selectedPriority.value !== props.initialState;
});

function reset() {
  selectedPriority.value = props.initialState;
}

function submit() {
  if (!isDirty.value) {
    return;
  }
  emit("submit", selectedPriority.value);
}

defineExpose({
  isDirty,
  reset,
  submit,
});
</script>
